module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "scrollable": "",
      "max-width": "60vw"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "color": "primary",
            "dark": "",
            "small": "",
            "icon": ""
          },
          on: {
            "click": _vm.editPermissions
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', {
          attrs: {
            "dark": "",
            "color": "info"
          }
        }, [_vm._v("mdi-account-edit")])], 1)]
      }
    }]),
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_vm._v(" "), _c('v-card', {
    staticStyle: {
      "overflow-y": "hidden"
    }
  }, [_c('v-card-title', {
    staticClass: "justify-center",
    attrs: {
      "primary-title": ""
    }
  }, [_c('h3', {
    staticClass: "headline mb-1 mt-2 ml-2"
  }, [_vm._v("\n        " + _vm._s(_vm.titleText) + "\n      ")])]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticStyle: {
      "height": "60vh"
    }
  }, [_c('v-overlay', {
    attrs: {
      "absolute": "",
      "value": _vm.overlay
    }
  }, [_c('v-container', {
    staticStyle: {
      "width": "40vw"
    }
  }, [_c('v-row', {
    attrs: {
      "align-content": "center",
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-progress-linear', {
    attrs: {
      "indeterminate": "",
      "height": "8"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.permissionsList,
      "item-key": "id",
      "sort-by": "id",
      "group-by": "actions",
      "checkbox-color": "blue",
      "fixed-header": "",
      "hide-default-footer": "",
      "disable-pagination": "",
      "show-select": "",
      "show-group-by": ""
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-row', {
    attrs: {
      "justify": "center"
    }
  }, [_c('v-container', {
    staticStyle: {
      "max-width": "50%"
    },
    attrs: {
      "justify-space-around": "",
      "d-flex": ""
    }
  }, [_c('v-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('action-button', {
    staticStyle: {
      "min-width": "100px"
    },
    attrs: {
      "color": "secondary",
      "label": "Close",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('action-button', {
    staticStyle: {
      "min-width": "100px"
    },
    attrs: {
      "color": "success",
      "label": "Save",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.saveChanges.apply(null, arguments)
      }
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d96bf0d2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/permissions/components/EditPermissions.vue
// module id = 1994
// module chunks = 0